// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__33Am9","container":"styles_container__3fFzT","title":"styles_title__2c-T6","wrapper":"styles_wrapper__zzle_","answer":"styles_answer__26wUe"};